<template>
  <section class="sub-menu">
    <div class="rew-containers">
      <div class="row">
        <div class="col-12">
          <ul class="sub-menu__list">
            <!-- <li class="sub-menu__list-item">
              <router-link
                :to="{ name: 'StudentDashboard', params: { id: id } }"
                event=""
                class="sub-menu__list-item-link"
                active-class="active"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.2222 4H5.77778C4.79594 4 4 4.79594 4 5.77778V18.2222C4 19.2041 4.79594 20 5.77778 20H18.2222C19.2041 20 20 19.2041 20 18.2222V5.77778C20 4.79594 19.2041 4 18.2222 4Z"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M4 9H20"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9 20V9"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </router-link>
            </li> -->

            <li
              v-for="(item, index) in studentMenu"
              :key="index"
              class="sub-menu__list-item"
            >
              <router-link
                v-if="
                  !item.permission || $perm(item.permission, user.campus_id)
                "
                :to="{
                  name: item.link,
                  params: { id: id },
                  query: item.query || {}
                }"
                class="sub-menu__list-item-link"
                :class="{
                  active:
                    $route.name === item.link &&
                    (item.query
                      ? $route.query.tab === item.query.tab
                      : !$route.query.tab)
                }"
              >
                {{ item.title }}
              </router-link>
            </li>
            <li class="sub-menu__list-item">
              <router-link
                v-if="
                  $perm(
                    'additional_data.can_see_in_student_personal_file',
                    user.campus_id
                  )
                "
                :to="{ name: 'StudentAdditionaDataTable', params: { id: id } }"
                :class="[
                  'sub-menu__list-item-link',
                  $route.name === 'StudentAdditionaDataTable' ? 'active' : ''
                ]"
              >
                נתונים ומדדים
              </router-link>
            </li>

            <li class="sub-menu__list-item">
              <router-link
                :to="{ name: 'StudentProject', params: { id: id } }"
                :class="[
                  'sub-menu__list-item-link',
                  $route.name === 'StudentProject' ? 'active' : ''
                ]"
              >
                תוכניות
              </router-link>
            </li>
            <li class="sub-menu__list-item">
              <router-link
                v-if="
                  $perm(
                    'student.view_behavior_exit_permissions',
                    user.campus_id
                  )
                "
                :to="{
                  name: 'StudentBehavior',
                  params: { id: id },
                  query: { tab: 'exit-permissions' }
                }"
                :class="[
                  'sub-menu__list-item-link',
                  $route.name === 'StudentBehavior' &&
                  $route.query.tab === 'exit-permissions'
                    ? 'active'
                    : ''
                ]"
              >
                אישורי יציאה
              </router-link>
            </li>

            <li class="sub-menu__list-item">
              <router-link
                v-if="$perm('student.view_behavior_attendance', user.campus_id)"
                :to="{
                  name: 'StudentBehavior',
                  params: { id: id },
                  query: { tab: 'attendance' }
                }"
                :class="[
                  'sub-menu__list-item-link',
                  $route.name === 'StudentBehavior' &&
                  $route.query.tab === 'attendance'
                    ? 'active'
                    : ''
                ]"
              >
                נוכחות
              </router-link>
            </li>

            <li class="sub-menu__list-item">
              <router-link
                :to="{ name: 'StudentBehavior', params: { id: id } }"
                :class="[
                  'sub-menu__list-item-link',
                  $route.name === 'StudentBehavior' && !$route.query.tab
                    ? 'active'
                    : ''
                ]"
              >
                תיעוד
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TheStudentMenu',
  props: ['id', 'user'],
  data() {
    return {
      studentMenu: [
        {
          link: 'StudentEdit',
          title: 'לוח חכם',
          query: { tab: 'smart' },
          permission: 'student.view_smart_dashboard'
        },
        {
          link: 'StudentEdit',
          title: 'פרטים אישיים'
        },
        // {
        //   link: 'StudentAdditionaDataTable',
        //   title: 'Additional-Data'
        // },
        {
          link: 'StudentSchool',
          title: 'בית הספר'
        },
        {
          link: 'StudentCenter',
          title: 'פנימיה'
        },
        {
          link: 'StudentReproachesTab',
          title: 'מערכת שעות'
        }
        // {
        //   link: 'StudentBehavior',
        //   title: 'תיעוד'
        // }
      ]
    };
  }
};
</script>

<style scoped>
/* .border-router {
  border-right: 1px solid black;
  margin-right: 8px;
} */
</style>
